export const MaxIdeaDepth = 3;
export const NoOwnerID = 'noOwner';

export enum IdeaSheetQueryParams {
  IdeaTab = 'ideaTab',
  SheetMode = 'sheetMode',
}
